<script lang="ts">
    import { onMount } from 'svelte'
    import MultiSelect from 'svelte-multiselect'
    import type { Search } from '../../modules/prospectApi/searches/search'
    import { SearchesRepository } from '../../modules/prospectApi/searches/searches.repository'
    import { SearchesService } from '../../modules/prospectApi/searches/searches.service'

    const entityRep = new SearchesRepository()
    const searchesS = new SearchesService(entityRep)

    export let selected = []

    let items = []

    async function get() {
        const result: Search[] = await searchesS.getAll()
        items = []
        for (const item of result) {
            if (item.status < 90) continue
            let label = item.category.name
            label += ' / '
            label += item.city.name
            label += ' (' + item.total + ')'
            items.push({
                label: label,
                value: item.searchId,
            })
        }
    }

    function assignLabel() {
        for (let item of selected) {
            const found = items.find((el) => el.value === item.value)
            if (found) {
                item.label = found.label
            }
        }
        selected = selected
    }

    onMount(async () => {
        await get()
        assignLabel()
    })
</script>

<MultiSelect noOptionsMsg="" bind:selected options={items} />

<style>
    :root {
        --sms-background: #212529;
        --sms-options-bg: #212529;
        --sms-border: 1px solid #99999925;
        --sms-padding: 8px;
    }
</style>
